import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./DetailedInventory.module.css";
import { FiPlay } from "react-icons/fi";
import Header from "../../components/header/Header";
import diamondEmerald from "../../assets/diamonds/diamond_emerald.png";
import certificateImg from "../../assets/images/certificate.png";
import PageHeading from "../../components/PageHeading/PageHeading";
import { useGetInventoryItemDetailsQuery } from "../../store/api/inventoryApi";

const DetailedInventory: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const inventoryId = id ? parseInt(id, 10) : 1;
  const [imgSrc, setImgSrc] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [previewFile, setPreviewFile] = useState(false);
  const { data, isLoading } = useGetInventoryItemDetailsQuery(inventoryId);
  const inv = data?.data;
  useEffect(() => {
    if (inv?.image_url) {
      const url = inv.image_url;
      const isVideoURL =
        url.endsWith(".html") ||
        url.includes("/VIDEO/") ||
        url.includes("nivoda-inhousemedia");
      setIsVideo(isVideoURL);
      setImgSrc(isVideoURL ? diamondEmerald : url);
    }
  }, [data?.data]);

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.mainContent}>
        <PageHeading title="Inventory Details" backTo="/?tab=inventory" />
        <div className={styles.content}>
          {/* Left Panel */}
          <div className={styles.leftPanel}>
            <img
              src={inv?.image_url || diamondEmerald}
              alt="Diamond"
              className={styles.sideImage}
              onClick={() => setShowVideo(false)}
            />
            <div className={styles.videoContainer}>
              <button
                className={styles.videoButton}
                aria-label="Play video"
                onClick={() => setShowVideo(true)}
              >
                <FiPlay />
              </button>
              <span className={styles.videoLabel}>VIDEO</span>
            </div>
            <img
              src={certificateImg}
              alt="Certificate"
              className={styles.certificate}
            />
          </div>
          {/* Center Image */}
          {/* <img
            src={inv?.image_url || diamondEmerald}
            alt="Diamond Large"
            className={styles.centerImage}
          /> */}
          {isVideo && showVideo ? (
            <iframe
              src={imgSrc}
              style={{
                height: "350px",
              }}
            />
          ) : (
            <img
              src={imgSrc || diamondEmerald}
              alt="Diamond"
              className={styles.centerImage}
              onError={() => setImgSrc(diamondEmerald)}
            />
          )}
          {/* Right Panel */}
          <div className={styles.rightPanel}>
            <div className={styles.primaryInfo}>
              <div className={styles.primaryInfoRow}>
                <div className={styles.label}>
                  Stocks#{" "}
                  <span className={styles.data}>{inv?.serial_id || "-"}</span>
                </div>
              </div>
              <div className={styles.primaryInfoRow}>
                <div className={styles.title}>
                  {inv?.shape || "-"} {inv?.carat || "-"}ct {inv?.color || "-"}{" "}
                  {inv?.clarity || "-"}
                </div>
              </div>
              <div className={styles.primaryInfoRow}>
                <div className={styles.label}>
                  Status:{" "}
                  <span className={styles.data}>
                    {inv?.is_sold ? "Sold" : "Available"}
                  </span>
                </div>
              </div>
            </div>

            {/* Price Table */}
            <table
              className={styles.detailsTable}
              aria-label="Price Details"
              style={{ marginBottom: 24 }}
            >
              <tr>
                <th
                  colSpan={2}
                  style={{
                    borderRight: "1px solid #e5e5e5",
                    borderBottom: "1px solid #e5e5e5",
                    fontSize: "1.18rem",
                    fontWeight: "600",
                  }}
                >
                  Price
                </th>
                <th className={styles.priceSubHeader}>P/ct</th>
                <th className={styles.priceSubHeader}>Total Price</th>
              </tr>

              <tbody>
                <tr>
                  <td> </td>
                  <td className={styles.priceValue}>
                    {inv?.price_per_carat ? `$${inv.price_per_carat}` : "-"}
                  </td>
                  <td className={styles.priceValue}>
                    {inv?.total_price ? `$${inv.total_price}` : "-"}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Product Details Table */}
            <table className={styles.detailsTable} aria-label="Product Details">
              <thead>
                <tr>
                  <th
                    colSpan={4}
                    style={{
                      borderRight: "none",
                      borderBottom: "1px solid #e5e5e5",
                      fontSize: "1.18rem",
                      fontWeight: "600",
                    }}
                  >
                    Product Details
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Lab</th>
                  <td>{inv?.lab || "-"}</td>
                  <th>Certificate</th>
                  <td>{inv?.certificate_number || "-"}</td>
                </tr>
                <tr>
                  <th>Shape</th>
                  <td>{inv?.shape || "-"}</td>
                  <th>Carat</th>
                  <td>{inv?.carat || "-"}</td>
                </tr>
                <tr>
                  <th>Color</th>
                  <td>{inv?.color || "-"}</td>
                  <th>Clarity</th>
                  <td>{inv?.clarity || "-"}</td>
                </tr>
                <tr>
                  <th>Cut</th>
                  <td>{inv?.cut || "-"}</td>
                  <th>Polish</th>
                  <td>{inv?.polish || "-"}</td>
                </tr>
                <tr>
                  <th>Symmetry</th>
                  <td>{inv?.symmetry || "-"}</td>
                  <th>Fluor</th>
                  <td>{inv?.fluorescent || "-"}</td>
                </tr>
                <tr>
                  <th>Location</th>
                  <td>{inv?.location || "-"}</td>
                  <th>Depth</th>
                  <td>
                    {inv?.depth_percentage ? `${inv.depth_percentage}%` : "-"}
                  </td>
                </tr>
                <tr>
                  <th>Table</th>
                  <td>
                    {inv?.table_percentage ? `${inv.table_percentage}%` : "-"}
                  </td>
                  <th>Gridle</th>
                  <td>{inv?.girdle || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedInventory;
